/* loaded by smart-asset */
export default require("./assets/red-tote.i.svg")